class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.parentLink = this.querySelector('[data-header-menu-parent-link]');
    if (!this.parentLink) return;

    // Parent item links to its own page; the submenu opens on hover (or focus) instead of on click.
    this.canHover = window.matchMedia('(hover: hover)');
    this.addEventListener('mouseenter', () => this.canHover.matches && this.open());
    this.addEventListener('mouseleave', () => this.canHover.matches && this.scheduleClose());
    this.addEventListener('focusin', () => this.canHover.matches && this.open());
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', (event) => {
      // With hover, clicking around the label must not toggle the submenu closed.
      if (this.canHover.matches && !this.parentLink.contains(event.target)) event.preventDefault();
    });
    this.parentLink.addEventListener('click', (event) => {
      // Touch screens have no hover: first tap shows the submenu, second tap follows the link.
      if (!this.canHover.matches && !this.mainDetailsToggle.open) {
        event.preventDefault();
        this.open();
      }
    });
  }

  open() {
    clearTimeout(this.closeTimer);
    // Only one dropdown at a time: close the others right away (skipping their close delay).
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle.open) {
        clearTimeout(menu.closeTimer);
        menu.close();
      }
    });
    if (this.mainDetailsToggle.open) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  scheduleClose() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.close(), 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
